// Vigie IA : le moteur de règles tourne côté serveur (MongoDB). Le frontend
// pousse un instantané à chaque ouverture / action puis lit les alertes.
import { snapshotVigie } from './dataProvider';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function synchroniserVigie() {
  const snap = await snapshotVigie();
  const r = await fetch(`${API}/vigie/sync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snap),
  });
  if (!r.ok) throw new Error('Synchronisation Vigie impossible');
  return r.json();
}

export async function fetchAlertes() {
  const r = await fetch(`${API}/vigie/alertes`);
  if (!r.ok) throw new Error('Lecture des alertes impossible');
  return r.json();
}

export async function traiterAlerte(id) {
  await fetch(`${API}/vigie/alertes/${id}/traiter`, { method: 'POST' });
}

export async function genererBrief() {
  const r = await fetch(`${API}/vigie/brief`, { method: 'POST' });
  return r.json();
}
